import './MessagingOptions.scss'
import { useIntl } from 'react-intl'
import { LuxIcon, LuxInputSwitch, useWindowResize } from '@lux/wardrobe-lib'
import { FormBase, MessagingOptionsForm } from '@models/new-activity-form'
import { SmartlyActionSubtypes } from '@Techedge/digitalportal-shared'

const MessagingOptions = (props: FormBase<MessagingOptionsForm>) => {
    const componentClass = 'smart-new-activity-main-info-messaging-options'
    const intl = useIntl()
    const { form, onSetForm } = props
    const isMobile = useWindowResize()

    return (
        <div className={componentClass}>
            {!form.confirmRead.hide &&
                form.type?.value !== SmartlyActionSubtypes.SERVICE_REQUEST && (
                    <div className={`${componentClass}__item`}>
                        <LuxInputSwitch
                            value={form.confirmRead.value}
                            onChangeCallback={(value: boolean) =>
                                onSetForm({ ...form, confirmRead: { ...form.confirmRead, value } })
                            }
                            label={intl.formatMessage({
                                id: 'modals.new.activity.section.main.info.confirm.reading',
                                defaultMessage: 'Confirm Reading',
                            })}
                            additionalProps={{ disabled: form.confirmRead.disabled }}
                        />
                    </div>
                )}
            <div className={`${componentClass}__item`}>
                <LuxInputSwitch
                    value={form.messagingEnabled.value}
                    onChangeCallback={(value: boolean) =>
                        onSetForm({
                            ...form,
                            messagingEnabled: { ...form.messagingEnabled, value: value },
                        })
                    }
                    label={intl.formatMessage({
                        id: 'modals.new.activity.section.main.info.enable.messaging',
                        defaultMessage: 'Enable messaging',
                    })}
                    additionalProps={{ disabled: form.messagingEnabled.disabled }}
                />
            </div>
            {props.enableCommentReaction && (
                <div className={`${componentClass}__item`}>
                    <LuxInputSwitch
                        value={form.commentReaction.value}
                        onChangeCallback={(value: boolean) =>
                            onSetForm({
                                ...form,
                                commentReaction: { ...form.commentReaction, value },
                            })
                        }
                        label={intl.formatMessage({
                            id: 'modals.new.activity.section.main.info.enable.comment.reaction',
                            defaultMessage: 'Enable comment and reaction',
                        })}
                        additionalProps={{ disabled: form.commentReaction.disabled }}
                    />
                </div>
            )}
            {!props.disableDisclaimer &&
                form.type?.value !== SmartlyActionSubtypes.SERVICE_REQUEST && (
                    <div className={`${componentClass}__item disclaimer`}>
                        <LuxIcon icon="info" />
                        <span className={isMobile ? 'text-mini' : 'text'}>
                            {intl.formatMessage({
                                id: 'modals.new.activity.section.main.info.confirm.reading.disclaimer',
                                defaultMessage:
                                    'Action is removed when Confirm Reading is active (ON).',
                            })}
                        </span>
                    </div>
                )}
        </div>
    )
}

export default MessagingOptions
